/** The notice's headline — also the meta line of the referred confirmation
 *  banner (`SubmittedBanner`), so the two cannot drift apart. */
export const REFERRAL_SENTENCE =
  "This submission will be sent to Signal for review.";

/**
 * The persistent, NON-BLOCKING referral notice. Shown from the moment a pull
 * settles non-pass, through every later step of the wizard — because the broker
 * is going to complete this submission either way, and the one thing they need
 * to know is that a human will look at it — and, `filed`, beneath the header of
 * a referred order's detail page (BRK-S278, design § 5.2). The detail page
 * passes no reasons: they were the wizard's local state from the data-pull
 * runs, and the order view publishes none.
 */
export function ReferralNotice({
  reasons,
  filed,
}: {
  reasons: string[];
  /** The order is already submitted — there is nothing left to carry on with. */
  filed?: boolean;
}) {
  return (
    <div className="flex flex-col gap-2 rounded-xl border border-amber-300 dark:border-amber-400/35 bg-amber-50 dark:bg-amber-400/10 p-4">
      <p className="text-sm font-semibold text-amber-900 dark:text-amber-200">
        {REFERRAL_SENTENCE}
      </p>
      <p className="text-sm text-amber-800 dark:text-amber-200">
        {filed
          ? "Nothing to do — our surety team will follow up."
          : "Nothing to do — carry on and finish it. Our team will follow up."}
      </p>
      {reasons.length > 0 && (
        <ul className="list-inside list-disc text-sm text-amber-800 dark:text-amber-200">
          {reasons.map((r) => (
            <li key={r}>{r}</li>
          ))}
        </ul>
      )}
    </div>
  );
}
